import { Link } from 'react-router-dom';
import { ArrowLeft, Smartphone } from 'lucide-react';
import { AppLayout } from '@/components/layout/AppLayout';
import { PwaInstallGuide } from '@/components/pwa/PwaInstallGuide';
import { Button } from '@/components/ui/button';

export default function InstallApp() {
  return (
    <AppLayout>
      <div className="max-w-lg mx-auto space-y-6 py-2">
        <div className="space-y-2">
          <Button asChild variant="ghost" size="sm" className="-ml-2 gap-1.5 text-muted-foreground">
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4" />
              Volver al panel
            </Link>
          </Button>
          <div className="flex items-center gap-3">
            <div className="rounded-xl bg-primary/10 p-3">
              <Smartphone className="h-7 w-7 text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">Instalar FOCO</h1>
              <p className="text-sm text-muted-foreground">Guía para Android e iPhone</p>
            </div>
          </div>
        </div>

        <PwaInstallGuide />

        <p className="text-xs text-muted-foreground text-center pb-4">
          Si ya instalaste la app, ábrela desde el icono en tu pantalla de inicio.
        </p>
      </div>
    </AppLayout>
  );
}
